module.exports = __webpack_public_path__ + "static/media/main_myjob_icon_1.909d232c.svg";